@if (icon()) {
  <mat-icon svgIcon="box" />
}
<span class="fsn-tag-text-content"><ng-content> </ng-content></span>
